/**
 * Per-match personal notes — stored locally in the browser. These are
 * private to the participant and never sent to the server; they get wiped
 * with the participant session.
 */

const KEY_PREFIX = "finally.meetup.match-note.";

export function getMatchNote(matchId: string): string {
  try {
    return localStorage.getItem(KEY_PREFIX + matchId) ?? "";
  } catch {
    return "";
  }
}

export function setMatchNote(matchId: string, note: string): void {
  try {
    if (note.trim().length === 0) {
      localStorage.removeItem(KEY_PREFIX + matchId);
    } else {
      localStorage.setItem(KEY_PREFIX + matchId, note);
    }
  } catch {
    /* storage unavailable — swallow */
  }
}
